// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged, getIdTokenResult } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export default function ProtectedRoute({
  children,
  requireMaster = false,
  redirectTo = "/",
}) {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      // Not signed in → block
      if (!user) {
        setAllowed(false);
        setChecking(false);
        return;
      }

      // 1) Custom claims (fast path)
      try {
        const { claims } = await getIdTokenResult(user); // no force refresh
        const admin  = claims.admin === true || claims.master === true;
        const master = claims.master === true;

        if (requireMaster ? (admin && master) : admin) {
          setAllowed(true);
          setChecking(false);
          return;
        }
      } catch (_) {
        // ignore and fall through
      }

      // 2) Firestore flags
      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          const d = snap.data() || {};
          const admin  =
            d.isAdmin === true || d.admin === true || typeof d.admin === "object";
          const master = d.isMaster === true || d.master === true;

          setAllowed(requireMaster ? (admin && master) : admin);
        } else {
          setAllowed(false);
        }
      } catch (err) {
        console.warn(
          "[ProtectedRoute] Firestore admin check failed – allowing access to unblock:",
          err
        );
        // 3) **Unblock** on any Firestore error
        setAllowed(true);
      } finally {
        setChecking(false);
      }
    });

    return () => unsub();
  }, [requireMaster, redirectTo]);

  if (checking) {
    return (
      <div style={{ textAlign: "center", marginTop: "3rem" }}>
        Checking access…
      </div>
    );
  }
  return allowed ? children : <Navigate to={redirectTo} replace />;
}
